import React from 'react';
import { ITeamProfile, TThemeColor } from '@mayfield/sanity';
import { useApp, useEmbla } from '@mayfield/website/hooks';
import {
  LayoutProvider,
  PaginationControls
} from '@mayfield/common/components';
import TeamProfileSlide from './components/TeamProfileSlide';
import * as styles from './styles.module.scss';

interface IProps {
  profiles: ITeamProfile[];
  centreTitle: string;
  centreThemeColor: TThemeColor;
  id?: string;
}

const TeamProfile = ({
  centreTitle,
  id,
  profiles,
  centreThemeColor
}: IProps) => {
  const {
    activeSlideIndex,
    emblaRef,
    scrollNext,
    scrollPrev,
    setActiveSlideIndex
  } = useEmbla(profiles.length);
  const { setBookATourSelectedCentre, setIsBookATourSidebarOpen } = useApp();

  const handleBookATourClick = () => {
    setIsBookATourSidebarOpen(true);
    setBookATourSelectedCentre({
      label: centreTitle,
      value: centreTitle
    });
  };

  const backgroundColor =
    profiles[activeSlideIndex].themeColor || centreThemeColor;

  const useCarousel = profiles.length > 1;

  return (
    <>
      {useCarousel && (
        <div
          style={{ background: `var(--color-${backgroundColor}-mid)` }}
          className={styles.carouselContainer}
          id={id}
          ref={emblaRef}
        >
          <div className={styles.carouselContent}>
            {profiles.map(({ image, text, title, themeColor }, i) => (
              <TeamProfileSlide
                key={i}
                handleBookATourClick={handleBookATourClick}
                image={image}
                text={text}
                title={title}
                themeColor={themeColor}
                className={styles.slide}
              />
            ))}
          </div>

          <LayoutProvider grid maxWidth padding>
            <div className={styles.paginationContainer}>
              <PaginationControls
                activeIndex={activeSlideIndex}
                numberOfItems={profiles.length}
                scrollNext={scrollNext}
                scrollPrev={scrollPrev}
                setActiveIndex={setActiveSlideIndex}
                className={styles.paginationControls}
                color="var(--color-buff)"
              />
            </div>
          </LayoutProvider>
        </div>
      )}

      {!useCarousel && (
        <div
          style={{ background: `var(--color-${backgroundColor}-mid)` }}
          className={styles.carouselContainer}
          id={id}
        >
          <TeamProfileSlide
            handleBookATourClick={handleBookATourClick}
            image={profiles[0].image}
            text={profiles[0].text}
            title={profiles[0].title}
            themeColor={profiles[0].themeColor}
            className={styles.slide}
          />
        </div>
      )}
    </>
  );
};

export default TeamProfile;
